"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasePriceFromTotalPrice = getBasePriceFromTotalPrice;
function getBasePriceFromTotalPrice(totalPrice) {
    return totalPrice.total - totalPrice.fee;
}
//# sourceMappingURL=getBasePriceFromTotalPrice.js.map